import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'
import { getSizeValues } from '../utils'

const withStyle = (TextInput) =>
  styled(TextInput)((props) => {
    const { size, theme, inline, rows } = props
    const { fontSize, lineHeight, footerAlign, height } = getSizeValues(
      size,
      theme
    )

    const textAreaRowHeight = stylesIf(
      rows === 1,
      `
      textarea {
        font-size: 14px;
        resize: both;
        padding: 11px;
        padding: 6px 11px 0px;
        height: 32px;
      }
    `
    )

    return `
        ${inline ? 'display: inline-block;' : ''}
        font-family: Arial;
        font-weight: normal;
        letter-spacing: normal;
        line-height: ${lineHeight};
        font-size: ${fontSize};

        .ant-select-selection__rendered {
          margin: 0;
        }

        .ant-select-selection {
          min-width: 50px;
        }

        .ant-select-disabled {
          .ant-select-selection,
          .ant-select-selection:hover,
          .ant-select-selection:focus {
            color: ${theme.inputFontDisabledColor};
            background-color: ${theme.inputBgDisabledColor};
            border-color: ${theme.inputBorderDisabledColor};
            box-shadow: none;
          }
        }

        >input, >textarea, .ant-select-selection {
          padding: 4px 11px;
          font-size: ${fontSize};
          line-height: ${lineHeight};
          min-height: ${height};
          width: 100%;
          border-radius: 3px;
          border: 1px solid;
          border-color: ${theme.inputBorderColor};
          background-color: ${theme.inputBgColor};
          color: ${theme.inputFontColor};
          &::placeholder {
            color: ${theme.inputPlaceholderColor};
          }
          &:focus {
            border-color: ${theme.inputBorderFocusColor};
            box-shadow: 0 0 2px ${theme.inputBorderFocusAccentColor};
            outline: none;
          }
          &:hover {
            border-color: ${theme.inputBorderHoverColor};
          }
          &-prefix {
            color: ${theme.prefixFontColor};
          }
          &-suffix {
            color: ${theme.suffixFontColor};
          }
          &[disabled], &-disabled {
            color: ${theme.inputFontDisabledColor};
            background-color: ${theme.inputBgDisabledColor};
            border-color: ${theme.inputBorderDisabledColor};
          }
          &.ant-select-selection {
            padding-top: 0;
          }
        }
        .input-footer {
          width: 100%;
          display: inline-block;
          text-align: ${footerAlign};
          font-size: 12px;
        }
        ${textAreaRowHeight}
      `
  })

export default withStyle

export const StyledFieldWrapper = styled.div((props) => {
  const { theme, errorState } = props
  const {
    inputBorderErrorColor,
    inputBorderErrorFocusColor,
    inputFooterErrorColor,
  } = theme

  return `
    display: flex;
    flex-direction: column;
    margin-bottom: 0px;
    flex: 1; 
    align-self: flex-end;
    position: relative;
    ${stylesIf(
      errorState,
      `
      >input, >textarea, .ant-select-selection {
        border-color: ${inputBorderErrorColor} !important;
        &:focus {
          border-color: ${inputBorderErrorColor} !important;
          box-shadow: 0 0 3px ${inputBorderErrorFocusColor} !important;
          outline: none !important;
        }
        &:hover {
          border-color: ${inputBorderErrorColor} !important;
        }
      }
      ${StyledFieldFooter} {
        color: ${inputFooterErrorColor};
      }
    `
    )}
  `
})

export const StyledFieldFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  position: absolute;
  bottom: -18px;
  left: 0;
  right: 0;
  pointer-events: none;
`

export const StyledErrorMessage = styled.span((props) => {
  const {
    theme: { inputDefaultFooterAlign, inputFooterErrorColor },
  } = props

  return `
    width: 100%;
    text-align: ${inputDefaultFooterAlign};
    color: ${inputFooterErrorColor};
  `
})

export const StyledCharsRemaining = styled.span`
  margin-left: auto;
`
